<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="padding-b pb-md-12"
      maxwidth-container="810px"
    >
      <Loading v-if="loading" />
      <ErrorServidor v-else-if="erro" />
      <template v-else>
        <TituloPagina
          class="mt-5 mt-md-11"
          :titulo="tituloDaPagina"
        />

        <p
          v-if="totalCard === 0"
          class="pa-0 mt-5 mt-md-6 mb-0 primary--text"
          data-cy="texto_da_pagina"
        >
          Cadastre seus endereços e receba com segurança suas compras!
        </p>

        <template v-if="listaEnderecos.length > 0">
          <template v-if="loadingLista">
            <v-skeleton-loader
              v-for="n in quantCardsLoading"
              :key="n"
              transition="transition"
              type="list-item-three-line"
              class="mt-6"
              loading
            />
          </template>
          <ListaEnderecos
            v-else
            :lista="listaEnderecos"
            @excluirCard="excluirCard($event)"
            @setPrincipal="setPrincipal"
          />
        </template>

        <template v-else>
          <v-img
            :alt="imgAlt"
            :src="require(`@/assets/img/${imgSrc}`)"
            :height="imgHeight"
            :width="imgWidth"
            class="mt-10 mx-md-auto"
          />
        </template>

        <div
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'botoes-rodape--desktop' : 'botoes-rodape--mobile',
            $vuetify.breakpoint.mdAndUp && listaEnderecos.length < 1
              ? 'botoes-rodape--menor mx-md-auto' : '',
          ]"
          class="grey lighten-3 botoes-rodape pa-3 mt-md-12 px-md-0"
        >
          <v-btn
            :width="$vuetify.breakpoint.mdAndUp ? '278' : '143'"
            color="primary"
            outlined
            exact
            to="/meu-perfil"
            data-cy="btn_voltar"
          >
            Voltar
          </v-btn>

          <v-btn
            :disabled="desabilitarCadastro"
            :width="$vuetify.breakpoint.mdAndUp ? '278' : '143'"
            color="primary"
            to="/meu-perfil/enderecos/cadastrar"
            data-cy="btn_novo_endereco"
          >
            {{ textoBtnCadastrar }}
          </v-btn>
        </div>

        <SnackBar
          :mensage="snackBar.message"
          :snackbar="snackBar.show"
          :button="true"
          :color="snackBar.color"
          :timeout="snackBar.timeout"
          @changeSnackBar="value => this.snackBar.show = value.visible"
        />
      </template>
    </InternaMain>
  </Wrapper>
</template>

<script>
import api from '@/api';

import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import ErrorServidor from '@/components/ErrorServidor.vue';
import Loading from '@/components/Loading.vue';
import ListaEnderecos from '@/components/MeuPerfil/Enderecos/ListaEnderecos.vue';
import SnackBar from '@/components/SnackBar.vue';

export default {
  name: 'Enderecos',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    ErrorServidor,
    Loading,
    ListaEnderecos,
    SnackBar,
  },

  data() {
    return {
      erro: false,
      imgAlt: 'Imagem ilustrativa para cadastre seu endereço.',
      imgHeight: '198',
      imgSrc: 'enderecos.svg',
      imgWidth: '320',
      listaEnderecos: {},
      loading: true,
      tituloDaPagina: 'Endereços',
      totalCard: 0,
      urlApi: {
        enderecos: '/address',
        setPrincipal: '/address/set-main/',
      },
      loadingLista: false,
      quantCardsLoading: 1,
      snackBar: {
        message: '',
        color: 'success',
        timeout: 6000,
        show: false,
      },
      snackBarMensagens: {
        error: 'Tente novamente mais tarde.',
        sucessoExcluir: 'Endereço excluído',
      },
    };
  },

  computed: {
    desabilitarCadastro() {
      return this.listaEnderecos.length >= 4;
    },
    textoBtnCadastrar() {
      return this.$vuetify.breakpoint.mdAndUp ? 'Novo endereço' : 'Novo';
    },
  },

  created() {
    this.getLista(true);
  },

  methods: {
    excluirCard(id) {
      this.loadingLista = true;
      this.quantCards(true);

      api.delete(`${this.urlApi.enderecos}/${id}`)
        .then(() => {
          this.getLista(false, true);
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : this.snackBarMensagens.error;
          this.setSnackbar(errorMessage, 'error');
          this.loadingLista = false;
        });
    },

    getLista(pagina = false, lista = false) {
      if (pagina) this.loading = true;
      if (lista) this.loadingLista = true;
      this.quantCards(true);

      api.get(this.urlApi.enderecos)
        .then((response) => {
          this.listaEnderecos = Object.values(response.data);

          if (lista) {
            this.setSnackbar(this.snackBarMensagens.sucessoExcluir);
          }
        })
        .catch(() => {
          this.erro = true;
        })
        .finally(() => {
          if (pagina) this.loading = false;
          if (lista) this.loadingLista = false;
          this.totalCard = Object.keys(this.listaEnderecos).length;
        });
    },

    setPrincipal(index, id) {
      this.loadingLista = true;
      this.quantCards();

      api.put(`${this.urlApi.setPrincipal}${id}`)
        .then(() => {
          this.listaEnderecos.forEach((itemLista) => {
            const item = itemLista;
            item.is_main = false;
          });
          this.listaEnderecos[index].is_main = true;
          this.loadingLista = false;
        })
        .catch((error) => {
          const { data } = error.response;
          const errorMessage = data.show ? data.error : this.snackBarMensagens.error;
          this.setSnackbar(errorMessage, 'error');
        })
        .finally(() => {
          this.loadingLista = false;
        });
    },

    quantCards(menosUm = false) {
      if (menosUm) {
        this.quantCardsLoading = (this.listaEnderecos.length <= 2)
          ? 1
          : this.listaEnderecos.length - 1;
      } else {
        this.quantCardsLoading = this.listaEnderecos.length;
      }
    },

    setSnackbar(mensagem, status = 'success', timeout = 6000) {
      this.snackBar.message = mensagem;
      this.snackBar.color = status;
      this.snackBar.timeout = timeout;
      this.snackBar.show = true;
    },
  },

};
</script>

<style lang="scss" scoped>
@import '~@/scss/botoes-fixos.scss';
</style>
